(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["layout-announcement-bar"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var swiper = new Swiper(".announcement-swiper", {
      slidesPerView: 1,
      spaceBetween: 0,
      autoplay: {
        delay: 5000
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var swiper = new Swiper(".blogSlide-swiper", {
    slidesPerView: 1.5,
    spaceBetween: 10,
    centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 3000
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-logo-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var swiper = new Swiper(".logo-list-swiper", {
      slidesPerView: 3.5,
      spaceBetween: 5,
      centeredSlides: true,
      loop: true,
      autoplay: {
        delay: 3000
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
